<template>
	<div>
		<div class="" style="position: relative;width:100%;height: 100%;">
			<div id="lsfzEcharts2" style="width:100%;height:100%;"></div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				data: [],
				myChart: ''
			}
		},
		mounted() {
			this.$request('/center/home/rightOne').then(res => {
				this.init(res.data.list);
			})
		},
		methods: {
			init(pageData) {
				let that = this
				this.myChart = echarts.init(document.getElementById("lsfzEcharts2"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});
				var option = {
					//你的代码
					// backgroundColor: '#153664',
				
					grid:{
						top:20,
						bottom:30,
						left:30
					},
					xAxis: [{
						type: 'category',
						axisLabel: {
							color: '#fff',
							textStyle: {
								fontSize: 10
							},
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#788eb0'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false,
							lineStyle: {
								color: '#788eb0'
							}
						},
						boundaryGap: false,
						data: ['12-10', '12-11', '12-12', '12-13', '12-14', '12-15', '12-16']
					}],
					yAxis: [{
						type: 'value',
						name: '',
						nameTextStyle: {
							color: '#fff',
							fontSize: 14,
							padding: [0, 0, 0, -30]
						},
						min: 0,
						axisLabel: {
							textStyle: {
								color: '#fff',
								fontSize: 10
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'gray'
							}
						}
					}],
					series: [{
						name: '次数',
						type: 'line',
						symbol: 'circle',
						symbolSize: 0,
						itemStyle: {
							normal: {
								color: '#2af7ff',
								lineStyle: {
									color: '#2af7ff',
									width: 3
								},
								areaStyle: {
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: 'RGBA(42, 247, 255, 0.2)'
										},
										{
											offset: 1,
											color: 'RGBA(42, 247, 255, 0.8)'
										}
									])
								}
							}
						},
						data: [20, 12, 11, 20, 20, 20, 8]
					}]
				};



				this.myChart.setOption(option);

				setInterval(function() {
					that.myChart.clear()
					that.myChart.setOption(option);
				}, 15000)
			}
		}
	}
</script>

<style scoped>
	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg {
		width: 30rpx;
		height: 30rpx;

	}
</style>